import { useEffect, useState, useRef } from "react";
import { Html5Qrcode } from "html5-qrcode";
import Header from "../Header";
import { useNavigate, generatePath, useParams } from "react-router-dom";
const QrScanner = ({ renderInComponent = false }) => {
  const { clientNameParam } = useParams();
  const [cameras, setCameras] = useState([]);
  const [selectedCameraId, setSelectedCameraId] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const html5QrCodeRef = useRef(null);
  const [scannedLink, setScannedLink] = useState(null);
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  const [hideSidebar, setHideSidebar] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    // setIsScanning(true);

    Html5Qrcode.getCameras()
      .then((devices) => {
        setCameras(devices);
        if (devices.length > 0) setSelectedCameraId(devices[0].id);
        //startScanning();
      })
      .catch((err) => console.error("Camera Error:", err));
  }, []);

  useEffect(() => {
    if (selectedCameraId && !isScanning) {
      startScanning();
    }
    // eslint-disable-next-line
  }, [selectedCameraId]);
  useEffect(() => {
    return () => {
      if (html5QrCodeRef?.current?.isScanning) {
        html5QrCodeRef.current
          .stop()
          .then(() => html5QrCodeRef.current.clear())
          .catch(() => {});
      }
    };
  }, []);

  const startScanning = () => {
    setIsScanning(true);
    if (!selectedCameraId) return;

    html5QrCodeRef.current = new Html5Qrcode("reader");

    html5QrCodeRef.current
      .start(
        selectedCameraId, // ✅ Only pass the camera ID here
        {
          fps: 10,
          qrbox: { width: 250, height: 250 },
        },
        (decodedText) => {
          //let url = decodedText.trim();
          // if (!url.startsWith("http://") && !url.startsWith("https://")) {
          //   url = "https://" + url; // Prepend https if missing
          // }
          setScannedLink(decodedText);
          window.open(decodedText, "_blank");
          setIsScanning(true);
          stopScanning();
        }
        // (errorMessage) => {
        //   console.warn("Scan error:", errorMessage);
        // }
      )
      .catch((err) => console.error("Start Scan Error:", err));
  };

  const stopScanning = () => {
    setIsScanning(false);
    if (html5QrCodeRef?.current?.isScanning) {
      html5QrCodeRef.current
        .stop()
        .then(() => html5QrCodeRef.current.clear())
        .catch((err) => console.error("Stop Scan Error:", err));
    }
  };

  // const scanImageFile = (event) => {
  //   const file = event.target.files[0];
  //   if (file && html5QrCodeRef.current) {
  //     html5QrCodeRef.current
  //       .scanFile(file, true)
  //       .then(decodedText => setScannedText(decodedText))
  //       .catch(err => console.error("Image Scan Error:", err));
  //   }
  // };
  const handleChange = (e) => {
    stopScanning();
    setSelectedCameraId(e.target.value);
  };
  const handleBack = () => {
    navigate(
      generatePath("/client/:clientNameParam/property-form", {
        clientNameParam,
      })
    );
  };
  return (
    <>
      <div>
        {renderInComponent ? null : (
          <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
        )}
      </div>
      <div
        className={`${
          renderInComponent ? "render-scanner" : "no-render-scanner mb-3"
        } mx-auto`}
      >
        <div className="form-floating mb-3">
          <select
            className="form-select"
            name="doorType"
            id="floatingSelect"
            aria-label="Floating label select example"
            value={selectedCameraId || ""}
            onChange={handleChange}
          >
            {cameras.map((cam) => (
              <option key={cam.id} value={cam.id}>
                {cam.label}
              </option>
            ))}
          </select>
          <label htmlFor="floatingSelect">Camera</label>
        </div>

        <div id="reader" style={{ width: "100%", margin: "20px auto" }} />

        <div className="d-flex gap-3">
          {isScanning == false && (
            <button
              className="btn btn-secondary flex-fill"
              type="button"
              onClick={startScanning}
            >
              Start Scanning
            </button>
          )}

          {isScanning == true && (
            <button
              className="btn btn-secondary flex-fill"
              type="button"
              onClick={stopScanning}
            >
              Stop Scanning
            </button>
          )}
          {isSafari && scannedLink && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.open(scannedLink, "_blank")}
            >
              Open Scanned Link
            </button>
          )}
          {!renderInComponent && (
            <button
              type="button"
              className="btn btn-secondary flex-fill"
              onClick={() => {
                handleBack();
              }}
            >
              Back
            </button>
          )}
        </div>
        <div>
          {/* <input type="file" className="btn btn-secondary w-auto w-100 flex-grow-1" accept="image/*" onChange={scanImageFile} /> */}
          {/* <strong>Door Reference Link:</strong> <a href={scannedText || "None"}>{scannedText}</a> */}
        </div>
      </div>
    </>
  );
};

export default QrScanner;
